import Hero from "@/sections/Hero";
import Statement from "@/sections/Statement";
import Marquee from "@/components/Marquee";
import Manifesto from "@/sections/Manifesto";
import Work from "@/sections/Work";
import About from "@/sections/About";
import Services from "@/sections/Services";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

export default function Home({ introDone }) {
    return (
        <main data-testid="home-page">
            <Hero introDone={introDone} />
            <Statement />
            <Marquee />
            <Manifesto />
            <Work />
            <About />
            <Services />
            <Contact />
            <Footer />
        </main>
    );
}
